import { Accessor, For } from "solid-js";

export const userIcon =
  "httsp://assets.myhubble.money/web-assets/user_icon.png";
export const assetHubbleFull =
  "https://assets.myhubble.money/web-assets/hubble_full.svg";
export const assetCardIcon =
  "https://assets.myhubble.money/web-assets/card_providers.png";
export const assetUpiApps =
  "https://assets.myhubble.money/web-assets/upi_apps.png";
export const assetUpiIcon = "https://assets.myhubble.money/web-assets/upi.png";
export const assetPhonePeUPI =
  "https://assets.myhubble.money/web-assets/upi-apps/phonepe_upi.png";
export const assetGooglePayUPI =
  "https://assets.myhubble.money/web-assets/upi-apps/google_pay_upi.png";
export const assetAmazonPayUPI =
  "https://assets.myhubble.money/web-assets/upi-apps/amazon_upi.png";
export const assetPaytmUPI =
  "https://assets.myhubble.money/web-assets/upi-apps/paytm_upi.png";
export const assetBhimUPI =
  "https://assets.myhubble.money/web-assets/upi-apps/bhim_upi.png";
export const assetCredUPI =
  "https://assets.myhubble.money/web-assets/upi-apps/cred_upi.png";
export const defaultCoin =
  "https://assets.myhubble.money/web-assets/coinIcon.svg";
export const assetPaymentHeader =
  "https://assets.myhubble.money/web-assets/payment_header.png";
export const assetAmazonLogoRoundedLarge =
  "https://assets.myhubble.money/web-assets/amazon-logo-rounded-large.png";
export const assetAmazonSDKBanner =
  "https://assets.myhubble.money/web-assets/amazon-voucher-banner-hd2.png";
export const assetVictoryIcon =
  "https://assets.myhubble.money/web-assets/victory_icon.png";
export const assetHubbleFrame =
  "https://assets.myhubble.money/web-assets/hubble-frame.png";
export const assetHubbleFrameLg =
  "https://assets.myhubble.money/web-assets/hubble-frame-lg.png";
export const placeholderCardBig =
  "https://assets.myhubble.money/web-assets/image_placeholder_big.png";
export const placeholderCard =
  "https://assets.myhubble.money/web-assets/image_placeholder.png";
export const assetTickBlack =
  "https://assets.myhubble.money/web-assets/tick_black.png";
export const assetTickGrey =
  "https://assets.myhubble.money/web-assets/tick_grey.png";
export const phonepeGpayPaytmLogo =
  "https://assets.myhubble.money/web-assets/upi_logo_phone_gpay_paytm.png";
export const upiLogoLongList =
  "https://assets.myhubble.money/web-assets/upi_logo_gpay_phonepe_paytm_cred_bhim.png";
export const upiLogoLongListMobile =
  "https://assets.myhubble.money/web-assets/upi_logo_list_mobile.png";
export const hubbleAssured =
  "https://assets.myhubble.money/web-assets/hubble_assured.png";
export const hubbleAssuredBigger =
  "https://assets.myhubble.money/web-assets/hubble_assured_bigger.png";
export const hubbleHeaderBgLines =
  "https://assets.myhubble.money/web-assets/header_bg_lines.png";
export const emojiFace1 =
  "https://assets.myhubble.money/web-assets/emoji-face-1.png";
export const emojiFace2 =
  "https://assets.myhubble.money/web-assets/emoji-face-2.png";
export const emojiFace3 =
  "https://assets.myhubble.money/web-assets/emoji-face-3.png";
export const checkIconBlue =
  "https://assets.myhubble.money/web-assets/check-icon-blue.png";
export const checkFilledGreen =
  "https://assets.myhubble.money/web-assets/check-filled-green.webp";
export const playstoreLogo =
  "https://assets.myhubble.money/web-assets/playstore-logo.png";
export const appleLogo =
  "https://assets.myhubble.money/web-assets/apple-logo.png";
export const appHomepageScreenshot =
  "https://assets.myhubble.money/web-assets/app-homepage-screenshot.png";
export const greenCheck =
  "https://assets.myhubble.money/web-assets/hubble-check.png";
export const cardGenerationFailed =
  "https://assets.myhubble.money/web-assets/card_failed_icon.png";
export const logoutIcon =
  "https://assets.myhubble.money/web-assets/logout-icon.png";
export const supportIcon =
  "https://assets.myhubble.money/web-assets/support-icon.png";
export const giftCardIcon =
  "https://assets.myhubble.money/web-assets/giftcard-icon.png";
export const discountIconGreenfill =
  "https://assets.myhubble.money/web-assets/discount-icon-greenfill.png";

export const assetHighlightClubWithOffers =
  "https://assets.myhubble.money/web-assets/highlights-icons/CLUB_WITH_OFFERS.png";
export const assetHighlightCantBeClubbedWithOffers =
  "https://assets.myhubble.money/web-assets/highlights-icons/CANT_BE_CLUBBED_WITH_OFFERS.png";

export const assetHighlightCanBeClubbedInATransaction =
  "https://assets.myhubble.money/web-assets/highlights-icons/CARDS_CAN_BE_CLUBBED.png";
export const assetHighlightCantBeClubbedInATransaction =
  "https://assets.myhubble.money/web-assets/highlights-icons/CARDS_CANT_BE_CLUBBED.png";

export const assetHighlightSingleTime =
  "https://assets.myhubble.money/web-assets/highlights-icons/SINGLE_TIME.png";
export const assetHighlightMultipleTimesUsage =
  "https://assets.myhubble.money/web-assets/highlights-icons/MULTIPLE_TIMES.png";

export const assetHighlightUseOnlineOffline =
  "https://assets.myhubble.money/web-assets/highlights-icons/ONLINE_OFFLINE.png";
export const assetHighlightUseOnline =
  "https://assets.myhubble.money/web-assets/highlights-icons/ONLINE.png";
export const assetHighlightUseOffline =
  "https://assets.myhubble.money/web-assets/highlights-icons/OFFLINE.png";
export const assetHighlightUseForSuscription =
  "https://assets.myhubble.money/web-assets/highlights-icons/SUBSCRIPTION.png";

export const assetHighlightOneYearValid =
  "https://assets.myhubble.money/web-assets/highlights-icons/VALID_FOR_ONE_YEAR.png";

export const profileIcon =
  "https://assets.myhubble.money/web-assets/profile-icon.png";
export const emptyStateDecoration =
  "https://assets.myhubble.money/web-assets/empty_state_decoration.png";

export const giftUnwrap =
  "https://assets.myhubble.money/web-assets/web_gift_unwrapping.json";

export const ribbonConfetti =
  "https://assets.myhubble.money/web-assets/web_ribbon_confetti.json";

export const checkedFloor =
  "https://assets.myhubble.money/web-assets/checked-floor.svg";

export const cartIcon =
  "https://assets.myhubble.money/web-assets/cart-icon.svg";

export const greenCircleCartIcon =
  "https://assets.myhubble.money/web-assets/green_circle_cart_icon.svg";

export const rupeeIconFill =
  "https://assets.myhubble.money/web-assets/rupee-icon-fill.svg";

export const cupIcon = "https://assets.myhubble.money/web-assets/cup-icon.svg";

export const giftImageWithBg =
  "https://assets.myhubble.money/web-assets/gift_hubble.png";

export const floorCheckedNoBg =
  "https://assets.myhubble.money/web-assets/gift_floor_bg.webp";

export const brandUnavailableModalDecorationPlug =
  "https://assets.myhubble.money/web-assets/brand_unavailability_modal_plug.webp";

export const brandUnavailableModalDecorationRibbon =
  "https://assets.myhubble.money/web-assets/brand_unavailability_modal_ribbon.webp";

export const loginRNRCircle =
  "https://assets.myhubble.money/web-assets/login-rnr-bg.png";

export const acmeLogo =
  "https://assets.myhubble.money/web-assets/acme-logo.png";

export const ribbon = "https://assets.myhubble.money/web-assets/ribbon.png";

export const ribbonBlack =
  "https://assets.myhubble.money/web-assets/corp-gifting/ribbon-black.svg";

export const browseAllIcon =
  "https://assets.myhubble.money/web-assets/browse-all-icon.svg";

export const coinIcon = "https://assets.myhubble.money/web-assets/coin.svg";

export const poweredByHubble =
  "https://assets.myhubble.money/web-assets/powered-by-hubble.webp";

export const giftLandingBgTop =
  "https://assets.myhubble.money/web-assets/gift_landing_bg_top.webp";

export const addIcon = "https://assets.myhubble.money/web-assets/add-icon.webp";

export const rewardsGif =
  "https://assets.myhubble.money/web-assets/hubble_rewards_web.gif";

export const successTick =
  "https://assets.myhubble.money/web-assets/procurement/success-tick.png";

export const failedCross =
  "https://assets.myhubble.money/web-assets/failed_cross.svg";

export const editIconBlack =
  "https://assets.myhubble.money/web-assets/edit_icon_black.svg";

export const physicalCardsOrderPlaced =
  "https://assets.myhubble.money/web-assets/physical_cards_order_placed.svg";

export const physicalCardsReadyToActivate =
  "https://assets.myhubble.money/web-assets/physical_cards_ready_to_activate.svg";

export const congratulationsText =
  "https://assets.myhubble.money/web-assets/congratulations_text.png";

export const axisLogo =
  "https://assets.myhubble.money/web-assets/corp-gifting/axis_logo_x3.webp";

export const axisFloorBgDesktop =
  "https://assets.myhubble.money/web-assets/axis-floor-bg.webp";

export const axisV2DesktopBg =
  "https://assets.myhubble.money/web-assets/axis_v3_desktop_bg.webp";

export const axisV2MobileBg =
  "https://assets.myhubble.money/web-assets/axis_v2_mobile_bg.webp";

export const emailIcon =
  "https://assets.myhubble.money/web-assets/email_icon_v2.png";

export const whatsappIconTransparentBg =
  "https://assets.myhubble.money/web-assets/whatsapp_icon_transparent_bg.png";

export const axisFloorBgMobile =
  "https://assets.myhubble.money/web-assets/axis_floor_bg_v2.png";
export const loginAsset =
  "https://assets.myhubble.money/web-assets/procurement/procurement-login-asset.webp";

export const creditCardSheildIcon =
  "https://assets.myhubble.money/web-assets/procurement/credit-card-shield-icon.webp";

export const invoiceIcon =
  "https://assets.myhubble.money/web-assets/procurement/invoice-icon.webp";

export const walletIcon =
  "https://assets.myhubble.money/web-assets/procurement/wallet-icon.webp";

export const squidLogo =
  "https://assets.myhubble.money/web-assets/procurement/squid-logo.webp";
export const infoIcon =
  "https://assets.myhubble.money/web-assets/procurement/info-icon.png";
export const piEmptyState =
  "https://assets.myhubble.money/web-assets/procurement/PI-Empty-State.webp";
// receiver_landing_bg.webp
export const recieverLandingbg =
  "https://assets.myhubble.money/web-assets/receiver_landing_bg.webp";

export const logoutRedIcon =
  "https://assets.myhubble.money/web-assets/logout_red_icon.svg";

export const logoutWhiteIcon =
  "https://assets.myhubble.money/web-assets/logout_white_icon.svg";

export const marqueeGradientLeft =
  "https://assets.myhubble.money/web-assets/marquee_gradient_left_2.svg";

export const marqueeGradientRight =
  "https://assets.myhubble.money/web-assets/marquee_gradient_right_2.svg";

export const brandDetailsGradientLeft =
  "https://assets.myhubble.money/web-assets/brand_details_gradient_left.svg";

export const brandDetailsGradientRight =
  "https://assets.myhubble.money/web-assets/brand_details_gradient_right.svg";

export const faqsGradientLeft =
  "https://assets.myhubble.money/web-assets/faqs_gradient_left.svg";

export const faqsGradientRight =
  "https://assets.myhubble.money/web-assets/faqs_gradient_right.svg";

export const emptyGiftsToppedUp =
  "https://assets.myhubble.money/web-assets/empty_gifts_topped_up.svg";

export const emptyGiftsDraft =
  "https://assets.myhubble.money/web-assets/empty_gifts_draft.svg";

export const donationIcon =
  "https://assets.myhubble.money/web-assets/donation-icon.webp";

export const greenTickLg =
  "https://assets.myhubble.money/web-assets/green_tick_lg.svg";

export const donationIconColored =
  "https://assets.myhubble.money/web-assets/donation-icon-colored.webp";

export const kettoSDKLoadingImage =
  "https://assets.myhubble.money/web-assets/ketto-loading-image.webp";

export const oneGiftCard =
  "https://assets.myhubble.money/web-assets/procurement/one_gift_card.webp";

export const physicalGiftCard =
  "https://assets.myhubble.money/web-assets/procurement/physical_gift_card.webp";

export const thematicGiftCard =
  "https://assets.myhubble.money/web-assets/procurement/thematic-gift-card-2.webp";

export const visaDebitCard =
  "https://assets.myhubble.money/web-assets/procurement/visa-debit-card-icici.webp";

export const giftCardBlue =
  "https://assets.myhubble.money/web-assets/procurement/gift_card_blue.svg";

export const close10x =
  "https://assets.myhubble.money/web-assets/procurement/close_10.svg";

export const hubbleOneHowToUseStep1 =
  "https://assets.myhubble.money/web-assets/procurement/hubble-one-how-to-use-step-1-v2.webp";
export const hubbleOneHowToUseStep2 =
  "https://assets.myhubble.money/web-assets/procurement/hubble-one-how-to-use-step-2.webp";
export const hubbleOneHowToUseStep3 =
  "https://assets.myhubble.money/web-assets/procurement/hubble-one-how-to-use-step-3.webp";
export const hubbleOneHowToUseStep4 =
  "https://assets.myhubble.money/web-assets/procurement/hubble-one-how-to-use-step-4.webp";
export const collapseIcon =
  "https://assets.myhubble.money/web-assets/procurement/collapse-icon.webp";

export const soundOffIcon =
  "https://assets.myhubble.money/web-assets/sound_off.svg";

export const soundOnIcon =
  "https://assets.myhubble.money/web-assets/sound_on.svg";

export const closeGreyIcon =
  "https://assets.myhubble.money/web-assets/close_grey_icon.svg";

export const heartDivider =
  "https://assets.myhubble.money/web-assets/heart_divider.svg";

export const GiftFromHubbleIcon =
  "https://assets.myhubble.money/web-assets/gift_from_hubble_gift_icon.webp";

export const hubbleAppNudgeHelperImage =
  "https://assets.myhubble.money/web-assets/hubble_app_nudge_helper_image.webp";

export const tdFloorBgDesktop =
  "https://assets.myhubble.money/web-assets/td_login_bg_v1.svg";

export const tdFloorBgMob =
  "https://assets.myhubble.money/web-assets/td_login_bg_mob.svg";

export const tdDesktopBg =
  "https://assets.myhubble.money/web-assets/td_desktop_bg.svg";

export const infoGreyIcom =
  "https://assets.myhubble.money/web-assets/info_grey.svg";

export const helpIcon =
  "https://assets.myhubble.money/web-assets/help_icon.svg";

export const loadingIconBlack =
  "https://assets.myhubble.money/web-assets/loading_icon_black.svg";

export const rightArrowBlack =
  "https://assets.myhubble.money/web-assets/right_arrow_white.svg";

export const rightArrowBlackSmall =
  "https://assets.myhubble.money/web-assets/right_arrow_black_small.svg";

export const deleteIconBlack =
  "https://assets.myhubble.money/web-assets/delete_icon_black.svg";

export const leftArrowGreyNoLine =
  "https://assets.myhubble.money/web-assets/left_arrow_grey_no_line.svg";

export const rightArrowWhite =
  "https://assets.myhubble.money/web-assets/right_arrow_blank.svg";

export const rightLineArrowWhite =
  "https://assets.myhubble.money/web-assets/arrow_right_white.svg";

export const selectIconDown =
  "https://assets.myhubble.money/web-assets/select_icon_down.svg";

export const selectIconUp =
  "https://assets.myhubble.money/web-assets/select_icon_up.svg";

export const squareCheckIconBlack =
  "https://assets.myhubble.money/web-assets/square_check_icon_black.svg";

export const deliveryDetailsIcon =
  "https://assets.myhubble.money/web-assets/delivery_details.svg";

export const rightLineArrowBlack =
  "https://assets.myhubble.money/web-assets/arrow_right_black.svg";

export const greenGrid =
  "https://assets.myhubble.money/web-assets/green_grid.svg";

export const blueGrid =
  "https://assets.myhubble.money/web-assets/blur_grid.svg";

export const yellowGrid =
  "https://assets.myhubble.money/web-assets/yellow_grid.svg";

export const plusIconBlack =
  "https://assets.myhubble.money/web-assets/plus_icon.svg";

export const plusIconWhite =
  "https://assets.myhubble.money/web-assets/plus_icon_white.svg";

export const leftArrowGrey =
  "https://assets.myhubble.money/web-assets/left_arrow_grey.svg";

export const greenCheckCircle =
  "https://assets.myhubble.money/web-assets/green_check_circle.svg";

export const blackCheckCircle =
  "https://assets.myhubble.money/web-assets/black_check_circle.svg";

export const supportBlackIcon =
  "https://assets.myhubble.money/web-assets/support_black_icon.svg";

export const notificationIcon =
  "https://assets.myhubble.money/web-assets/notification_icon.svg";

export const downloadCsv =
  "https://assets.myhubble.money/web-assets/download_csv.svg";

export const viewInvoice =
  "https://assets.myhubble.money/web-assets/view_invoice.svg";

export const trackStatus =
  "https://assets.myhubble.money/web-assets/track_status.svg";

export const sendEmail =
  "https://assets.myhubble.money/web-assets/send_email.svg";

export const blueCheckmark =
  "https://assets.myhubble.money/web-assets/blue_checkmark.svg";

export const trackOrder =
  "https://assets.myhubble.money/web-assets/track_order.svg";

export const greenGiftCard =
  "https://assets.myhubble.money/web-assets/green_gift_card.svg";

export const giftCardOutlineBlack =
  "https://assets.myhubble.money/web-assets/gift_card_outline_black.svg";

export const arrowTopRight =
  "https://assets.myhubble.money/web-assets/arrow_top_right.svg";

export const copyIconBlack =
  "https://assets.myhubble.money/web-assets/copy_black.svg";

export const copiedIconGreen =
  "https://assets.myhubble.money/web-assets/copied_green.svg";

export const plusDenominationIcon =
  "https://assets.myhubble.money/web-assets/plus_denomination_icon.svg";

export const minusDenominationIcon =
  "https://assets.myhubble.money/web-assets/minus_denomination_icon.svg";

export const seeBrandsArrow =
  "https://assets.myhubble.money/web-assets/see_brands_arrow.svg";

export const listBlackIcon =
  "https://assets.myhubble.money/web-assets/list_black_icon.svg";

export const winnerRewardsIcon =
  "https://assets.myhubble.money/web-assets/winner_rewards_icon.svg";

export const addCircularFilledBlack =
  "https://assets.myhubble.money/web-assets/add_circular_filled_black.svg";

export const scratchCardBg =
  "https://assets.myhubble.money/web-assets/scratch_card_cover_tp.webp";

export const shelcalTotalLogo =
  "https://assets.myhubble.money/web-assets/shelcal_logo.png";

export const tpLogo =
  "https://assets.myhubble.money/web-assets/torrent_pharam_logo.png";

export const shelcalLoginBg =
  "https://assets.myhubble.money/web-assets/shelcal_login_bg.webp";

export const blueLight =
  "https://assets.myhubble.money/web-assets/blue_light.webp";

export const yellowLight =
  "https://assets.myhubble.money/web-assets/yellow_light.webp";

export const scratchCardRevealedBg =
  "https://assets.myhubble.money/web-assets/scratch_card_revealed_bg.webp";

export const shelcal500Logo =
  "https://assets.myhubble.money/web-assets/Shelcal_500_logo.png";

export const tpHomeBg =
  "https://assets.myhubble.money/web-assets/tp_home_bg.webp";

export const tpBanner01 =
  "https://assets.myhubble.money/web-assets/tp_banner_01.webp";

export const tpBanner02 =
  "https://assets.myhubble.money/web-assets/tp_banner_02.webp";

export const tpBanner03 =
  "https://assets.myhubble.money/web-assets/tp_banner_03.webp";

export function StarRow({
  starSizes,
  fillColor,
  altFillColor,
  breakpoint,
}: {
  starSizes: number[];
  fillColor: string;
  altFillColor?: string;
  breakpoint?: string;
}) {
  return (
    <For each={starSizes}>
      {(size) => (
        <>
          <div class={`h-${size} w-${size} ${breakpoint}:hidden`}>
            <LoginRnRStar fill={altFillColor} />
          </div>
          <div class={`hidden h-${size} w-${size} ${breakpoint}:flex`}>
            <LoginRnRStar fill={fillColor} />
          </div>
        </>
      )}
    </For>
  );
}

export function LoginRnRStar({
  class: className,
  fill: fillColor,
}: {
  class?: string;
  fill?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class={className}
      viewBox="0 0 14 14"
      fill={fillColor ?? "#E47B00"}
    >
      <path d="M7 0.5C7.60886 3.80507 10.1949 6.39113 13.5 7C10.1949 7.60886 7.60886 10.1949 7 13.5C6.39113 10.1949 3.80507 7.60886 0.5 7C3.80507 6.39113 6.39113 3.80507 7 0.5Z" />
    </svg>
  );
}

export const editIconFilledWhite =
  "https://assets.myhubble.money/web-assets/edit_icon_filled_white.svg";

export const editIconBlack16 =
  "https://assets.myhubble.money/web-assets/edit_icon_16x16.svg";

export const whatsappLogo =
  "https://assets.myhubble.money/web-assets/whatsapp_logo.svg";

export const giftCardPurple =
  "https://assets.myhubble.money/web-assets/gift-card-purple.png";

export const piggyBankIcon =
  "https://assets.myhubble.money/web-assets/piggy-bank.svg";

export const occasionalSpends =
  "https://assets.myhubble.money/web-assets/occasional-spends.svg";

export const routineSpends =
  "https://assets.myhubble.money/web-assets/routine-spends.svg";

export const seasonalSpends =
  "https://assets.myhubble.money/web-assets/seasonal-spends.svg";

export const giftsRibbonLg =
  "https://assets.myhubble.money/web-assets/gifts-ribbon-lg.svg";

export const giftsRibbonSM =
  "https://assets.myhubble.money/web-assets/gifts-ribbon-sm.svg";

export const checkIconBlack =
  "https://assets.myhubble.money/web-assets/sign-checkmark.svg";

export const hubbleRewardsTextLg =
  "https://assets.myhubble.money/web-assets/hubble_rewards_text.svg";

export const hubbleLogoSmall =
  "https://assets.myhubble.money/web-assets/hubble_logo_small.svg";

export const activeLinkGradient =
  "https://assets.myhubble.money/web-assets/procurement/active_link_gradient.svg";

export const hubbleRewardsTextSM =
  "https://assets.myhubble.money/web-assets/hubble_rewards_text_sm.png";

export const downloadHubbleQRCode =
  "https://assets.myhubble.money/web-assets/download_hubble_qr.png";

export const novaStar =
  "https://assets.myhubble.money/web-assets/nova_star.svg";

export const novaChatBubbleTop =
  "https://assets.myhubble.money/web-assets/nova_chat_bubble_top.svg";

export const novaChatBubbleBtm =
  "https://assets.myhubble.money/web-assets/nova_chat_bubble_bottom.svg";

export const plutoGiftBtmRight =
  "https://assets.myhubble.money/web-assets/pluto_gift_bottom_right.svg";

export const userCircle =
  "https://assets.myhubble.money/web-assets/user_circle.svg";

export const novaCircleStar =
  "https://assets.myhubble.money/web-assets/nova_circular_star.svg";

export const novaLoadingBubble =
  "https://assets.myhubble.money/web-assets/nova_loading_bubble.svg";

export const novaLinkGradient =
  "https://assets.myhubble.money/web-assets/nova_link_gradient.svg";

export const flipIcon =
  "https://assets.myhubble.money/web-assets/flip_icon.svg";

export const editIcon =
  "https://assets.myhubble.money/web-assets/edit_icon.svg";

export const editWhiteIcon =
  "https://assets.myhubble.money/web-assets/edit_icon_white.svg";

export const editCircularIcon =
  "https://assets.myhubble.money/web-assets/edit.svg";

export const giftIcon =
  "https://assets.myhubble.money/web-assets/gift_icon.svg";

export const giftWhiteIcon =
  "https://assets.myhubble.money/web-assets/gift_white_icon.svg";

export const editAICircularIcon =
  "https://assets.myhubble.money/web-assets/ai_edit.svg";

export const budgetInputBG =
  "https://assets.myhubble.money/web-assets/bg_budget_input.svg";

export const failureIcon =
  "https://assets.myhubble.money/web-assets/failure_icon.svg";

export const plutoLogo =
  "https://assets.myhubble.money/web-assets/pluto_logo_v3.webp";

export const plutoLogoSM =
  "https://assets.myhubble.money/web-assets/pluto_logo_sm.svg";

export const plutoMainLogoV2 =
  "https://assets.myhubble.money/web-assets/pluto_main_logo.webp";

export const plutoMsgPill =
  "https://assets.myhubble.money/web-assets/hey_pluto_pill_v2.png";

export const supportWhiteIcon =
  "https://assets.myhubble.money/web-assets/support_white.svg";

export const userWhiteCircle =
  "https://assets.myhubble.money/web-assets/user_profile_white.svg";

export const onboardingGiftCard =
  "https://assets.myhubble.money/web-assets/onboarding_gift.svg";

export const plutoBrand1 =
  "https://assets.myhubble.money/web-assets/pluto_brand_1.svg";
export const plutoBrand2 =
  "https://assets.myhubble.money/web-assets/pluto_brand_2.svg";
export const plutoBrand3 =
  "https://assets.myhubble.money/web-assets/pluto_brand_3.svg";

export const hubbleLogoPurple =
  "https://assets.myhubble.money/web-assets/hubble_logo_purple.svg";
export const cardCover =
  "https://assets.myhubble.money/web-assets/card_cover.svg";

export const plutoReceiverBg =
  "https://assets.myhubble.money/web-assets/pluto_receiver_bg.svg";

export const giftClassificationChart =
  "https://assets.myhubble.money/web-assets/gift_classification_chart.svg";

export const razorpayLogoGrey =
  "https://assets.myhubble.money/web-assets/razorpay_logo_grey.svg";

export const copyIcon =
  "https://assets.myhubble.money/web-assets/copy_icon.svg";

export const copyWhiteIcon =
  "https://assets.myhubble.money/web-assets/copy_white_icon_v2.svg";

export const invoiceDocumentIcon =
  "https://assets.myhubble.money/web-assets/invoice_icon.svg";

export const contactSupportIcon =
  "https://assets.myhubble.money/web-assets/contact_support_icon.svg";

export const invoiceHeader =
  "https://assets.myhubble.money/web-assets/invoice_header.svg";

export const linkedinLogo =
  "https://assets.myhubble.money/web-assets/linkedin_logo.svg";

export const facebookLogo =
  "https://assets.myhubble.money/web-assets/facebook_logo.svg";

export const twitterLogo =
  "https://assets.myhubble.money/web-assets/twitter_logo.svg";

export const giftLoading =
  "https://assets.myhubble.money/web-assets/gift_loading.json";

export const giftGenerationGlitter =
  "https://assets.myhubble.money/web-assets/gift_generation_glitter.json";

export const gift_cover_v2 =
  "https://assets.myhubble.money/web-assets/gift_cover_v2.webp";

export const onboarding_bg_mobile =
  "https://assets.myhubble.money/web-assets/onboarding_bg_mobile.webp";

export const onboarding_sample_gift =
  "https://assets.myhubble.money/web-assets/onboarding_sample_gift.webp";

export const glitter_lottie =
  "https://assets.myhubble.money/web-assets/Glitter.json";

export const createdUsingPlutoBranding =
  "https://assets.myhubble.money/web-assets/created_using_pluto_branding.webp";

export const pluto_onboarding_brands_icon =
  "https://assets.myhubble.money/web-assets/pluto_onboarding_brands_icon.webp";

export const closeIcon =
  "https://assets.myhubble.money/web-assets/close_icon.svg";

export const closeIconSM =
  "https://assets.myhubble.money/web-assets/close_icon_sm.svg";

export const pluto_reveal_meta_image =
  "https://assets.myhubble.money/web-assets/pluto_reveal_meta_image.webp";

export const telegram_logo =
  "https://assets.myhubble.money/web-assets/telegram_logo.png";

export const classification_arrows_v2 =
  "https://assets.myhubble.money/web-assets/classification_arow_v2.webp";

export const backArrowLeft =
  "https://assets.myhubble.money/web-assets/back_arrow_left.svg";

export const dotMenu = "https://assets.myhubble.money/web-assets/dot_menu.svg";

export const plutoLogoName =
  "https://assets.myhubble.money/web-assets/pluto_logo_name.webp";

export const happyBirthdaySmartGreeting =
  "https://assets.myhubble.money/web-assets/happy_birthday_smart_greeting.svg";

export const noResultsFound =
  "https://app.myhubble.money/static/uploads/no-results-found.svg";

export const shareIconSmartGC =
  "https://assets.myhubble.money/web-assets/share_smart_gc.svg";

export const smartGreetingCardVideo =
  "https://assets.myhubble.money/web-assets/smart_greeting_card.mov";

export const hubbleLogoSmartGCCover =
  "https://assets.myhubble.money/web-assets/hubble-smart-gc-cover-image.webp";

export const hubbleCodeBanner =
  "https://assets.myhubble.money/web-assets/hubble_code_banner.webp";

export const playstore_badge_dark =
  "https://assets.myhubble.money/web-assets/playstore_badge_dark.webp";

export const appstore_badge_dark =
  "https://assets.myhubble.money/web-assets/appstore_badge_dark.webp";

export const giftCardIconGrey =
  "https://assets.myhubble.money/web-assets/gift_card_icon.svg";

export const arrowLeftIcon =
  "https://assets.myhubble.money/web-assets/arrow_left.svg";

export const bankTransfer =
  "https://assets.myhubble.money/web-assets/bank_transfer.svg";

export const threeDotsVerticalIcon =
  "https://assets.myhubble.money/web-assets/three_dots_vertical.svg";

export const closeIconBlack =
  "https://assets.myhubble.money/web-assets/close_icon_black.svg";

export const squidLoginHeaderMobileBg =
  "https://assets.myhubble.money/web-assets/procurement/squid-login-mobile-header-bg.svg";

export const officeIcon =
  "https://assets.myhubble.money/web-assets/office_icon.svg";

export const phoneIcon =
  "https://assets.myhubble.money/web-assets/phone_icon.svg";

export const emailIconBlack =
  "https://assets.myhubble.money/web-assets/email_icon.svg";

export const userProfileCircle =
  "https://assets.myhubble.money/web-assets/user_profile_circle.svg";

export const refreshIcon =
  "https://assets.myhubble.money/web-assets/refresh.svg";

export const raisoniLoginBgMobile =
  "https://assets.myhubble.money/web-assets/corp-gifting/raisoni-login-bg-mobile.webp";

export const raisoniLoginBgDesktop =
  "https://assets.myhubble.money/web-assets/corp-gifting/raisoni-login-bg-desktop.webp";

export const raisoniLogoWhite =
  "https://assets.myhubble.money/web-assets/corp-gifting/raisoni_logo_white.webp";

export const upiLogo = "https://assets.myhubble.money/web-assets/upi_logo.svg";

export const netBankingIcon =
  "https://assets.myhubble.money/web-assets/net_banking_icon.svg";

export const netBankingWhiteIcon =
  "https://assets.myhubble.money/web-assets/net_banking_icon_white.svg";

export const greenCheckCircleLg =
  "https://assets.myhubble.money/web-assets/green_check_icon.svg";

export const tdMobileBg =
  "https://assets.myhubble.money/web-assets/td_mobile_bg.svg";

export const dropdownList =
  "https://assets.myhubble.money/web-assets/dropdown_list.svg";

export const dropdownListBlack =
  "https://assets.myhubble.money/web-assets/corp-gifting/dropdown_list_black_sm.svg";

export const poweredByHubbleBrandingWithGradient =
  "https://assets.myhubble.money/web-assets/vertical_drap_branding_gradient.svg";

export const cardBtmBranding =
  "https://assets.myhubble.money/web-assets/card_btm_branding.svg";

export const instoreTagIcon =
  "https://assets.myhubble.money/web-assets/instore-tag-icon.png";

export const onlineTagIcon =
  "https://assets.myhubble.money/web-assets/online-tag-icon.png";

export const subscriptionTagIcon =
  "https://assets.myhubble.money/web-assets/subscription-tag-icon.png";

export const generatingIcon =
  "https://assets.myhubble.money/web-assets/procurement/generating.svg";

export const defaultAppGiftCardBackgroundImage =
  "https://s3.ap-south-1.amazonaws.com/assets.hubble/gifting/app-gifting/templates/default.png";

export const threeDots20x =
  "https://assets.myhubble.money/web-assets/three_dots_20.svg";

export const tdCardFacia =
  "https://assets.myhubble.money/web-assets/td_card_facia.png";

export const tdV3DesktopBg =
  "https://assets.myhubble.money/web-assets/td_v3_desktop_bg.webp";

export const tdV3MobileBg =
  "https://assets.myhubble.money/web-assets/td_v3_mobile_bg.png";

export const tataNeuCardLogo =
  "https://assets.myhubble.money/web-assets/tata_neu_card_logo.png";
export const signCheckMarkIcon =
  "https://assets.myhubble.money/web-assets/procurement/sign-checkmark-pgc.webp";

export const discountIconGreen =
  "https://assets.myhubble.money/web-assets/procurement/discount-icon-pgc.webp";

export const multibrandCardEffectLeftAsset =
  "https://assets.myhubble.money/web-assets/procurement/card-bg-effect-left-asset.png";
export const multibrandCardEffectRightAsset =
  "https://assets.myhubble.money/web-assets/procurement/card-bg-effect-right-asset.png";

export const physicalCardIcon =
  "https://assets.myhubble.money/web-assets/procurement/physical-card-icon.webp";

export const errorImageV2 =
  "https://assets.myhubble.money/web-assets/error_image_v2.png";

export const csvInstructionAsset1 =
  "https://assets.myhubble.money/web-assets/csv_instruction_asset_1.png";

export const csvInstructionAsset2 =
  "https://assets.myhubble.money/web-assets/csv_instruction_asset_2.png";

export const csvInstructionAsset3 =
  "https://assets.myhubble.money/web-assets/csv_instruction_asset_3.png";

export const csvInstructionAsset4 =
  "https://assets.myhubble.money/web-assets/csv_instruction_asset_4.png";

export const csvInstructionAsset5 =
  "https://assets.myhubble.money/web-assets/csv_instruction_asset_5.png";

export const csvInstructionAsset6 =
  "https://assets.myhubble.money/web-assets/csv_instruction_asset_6.png";

export const csvInstructionAsset7 =
  "https://assets.myhubble.money/web-assets/csv_instruction_asset_7.png";

export function HubbleFullSvg({
  class: className,
  fill: fillColor,
}: {
  class?: string;
  fill?: string;
}) {
  return (
    <svg
      class={className}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1890.21 351.66"
      fill={fillColor}
    >
      <path
        d="M716.49,488.65q21.45,25.17,21.44,68.43V684.22h-76V566.84q0-19.1-9.93-29.83c-6.65-7.14-15.53-10.72-26.72-10.72q-17.18,0-27.3,11.13T587.8,568V684.25H511V395.65H587.8V502.14a70.63,70.63,0,0,1,27.3-28.09q17.92-10.53,42.13-10.52Q695,463.46,716.49,488.65Zm210.57,92.61q0,19.89-10.13,30.83T889.63,623q-16.78,0-26.72-10.72T853,582.84V465.46H776.53V592.22q0,43.69,21.65,68.84t59.46,25.14q24.17,0,42.13-10.52a70.78,70.78,0,0,0,27.29-28.08v36.65h76.45V465.46H927.06ZM1267.93,515Q1280,540.3,1280,574.62t-12.09,59.87q-12.11,25.56-33.16,39A85.8,85.8,0,0,1,1187.58,687q-23,0-39.77-9.94a61.67,61.67,0,0,1-25-27.5v34.7H1046V395.62h76.82V500.15a61.49,61.49,0,0,1,25-27.5q16.79-10,39.77-9.93,26.13,0,47.19,13.46T1267.93,515Zm-65.53,59.67q0-21.06-11.12-33c-7.4-7.92-17.11-11.89-29-11.89q-17.18,0-28.46,12.09t-11.31,32.75q0,21.06,11.31,33.15t28.46,12.09c11.94,0,21.65-4,29-11.88S1202.4,588.92,1202.4,574.62ZM1532.75,515q12.11,25.35,12.09,59.67t-12.09,59.87q-12.11,25.56-33.15,39A85.86,85.86,0,0,1,1452.4,687q-23,0-39.77-9.94a61.72,61.72,0,0,1-25-27.5v34.7h-76.82V395.62h76.82V500.15a61.55,61.55,0,0,1,25-27.5q16.78-10,39.77-9.93,26.13,0,47.2,13.46T1532.75,515Zm-65.52,59.67q0-21.06-11.13-33t-29-11.89c-11.45,0-20.91,4-28.46,12.09s-11.3,19-11.3,32.75q0,21.06,11.3,33.15c7.55,8.07,17,12.09,28.46,12.09q17.92,0,29-11.88T1467.23,574.62Zm108.4,109.6h76.83V395.62h-76.83Zm327.61-95.56H1758.53q2,37.07,32.37,37.06,11.32,0,18.73-5.45a27.29,27.29,0,0,0,10.14-14.42h81.11a92.65,92.65,0,0,1-19.11,41.54,102.6,102.6,0,0,1-37.44,29.05Q1821.7,687,1794.81,687q-32.77,0-57.92-13.46a95.09,95.09,0,0,1-39.19-39q-14-25.53-14-59.87t14-59.67a95.25,95.25,0,0,1,39.39-38.8q25.35-13.47,57.72-13.46,32.78,0,57.71,13.25a94.77,94.77,0,0,1,38.81,37.85q13.85,24.56,13.83,56.93A88.69,88.69,0,0,1,1903.24,588.66Zm-76-32q.39-16.77-9-25.34c-6.24-5.71-14-8.6-23.4-8.6q-15.19,0-24.76,8.6c-6.38,5.71-10.08,14.18-11.13,25.34Zm-1545-159.53a42.74,42.74,0,0,0,4.29-20.89h0a43,43,0,0,0-74.53-27.21h0L38.05,539.75a86.4,86.4,0,1,0,143.6,90.72Zm32.66,158a64.94,64.94,0,1,0,64.94,64.94A64.94,64.94,0,0,0,314.82,555.16Z"
        transform="translate(-14.95 -335.3)"
      />
    </svg>
  );
}

export const smsPreviewFooter =
  "https://assets.myhubble.money/web-assets/sms_preview_footer.png";

export const smsPreviewHeader3 =
  "https://assets.myhubble.money/web-assets/sms_preview_header_3.png";

export const whatsappPreviewChatBg =
  "https://assets.myhubble.money/web-assets/whatsapp_preview_chat_bg.webp";

export const whatsappPreviewFooter =
  "https://assets.myhubble.money/web-assets/whatsapp_preview_footer.png";

export const whatsappPreviewHeader =
  "https://assets.myhubble.money/web-assets/whatsapp_preview_header_2.png";

export const hubbleLogoFull1Oct2025 =
  "https://assets.myhubble.money/web-assets/hubble_logo_full_1oct2025.png";
